<template>
  <div class="container">
    <div class="topContainer">
      <el-form size="small" :model="form" style="width: 87%;" ref="refForm" :rules="rules" label-width="180px">
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{ $t('deliveryGoods.deliveryInformation') }}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="12">
            <el-form-item :label="$t('common.shipmentNumber') + ':'" prop="no">
              <el-input
                v-model.trim="form.no"
                name="shipmentNumber"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="255"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.selectCustomerInformation')}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="12">
            <el-form-item :label="$t('common.customerName') + ':'" prop="customerId">
              <el-select
                v-model="form.customerId"
                clearable
                filterable
                style="width: 100%;"
                size="small"
                @change="changeCustomer">
                <el-option
                  v-for="item in customersList"
                  :key="item.id"
                  :label="item.customerName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('common.contact') + ':'" prop="contact">
              <el-input
                v-model.trim="form.contact"
                name="contact"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="16">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="12">
            <el-form-item :label="$t('common.contactPhone') + ':'" prop="contactPhone">
              <el-input
                v-model.trim="form.contactPhone"
                name="contactPhone"
                type="tel"
                autocomplete="on"
                clearable
                size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('common.address') + ':'" prop="contactAddr">
              <el-input
                v-model.trim="form.contactAddr"
                name="contactAddr"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="24">
            <el-form-item :label="$t('common.comment') + ':'">
              <el-input
                v-model="form.comment"
                name="comment"
                type="textarea"
                autocomplete="on"
                clearable
                size="small"
                maxlength="255"
                :rows="3"
                show-word-limit>
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{ $t('device.confirmInfo') }}</h4>
        </el-form-item>
      </el-form>
      <div class="target-container">
        <el-tabs v-model="activeName">
          <el-tab-pane :label="$t('common.device')" name="device"></el-tab-pane>
          <el-tab-pane :label="$t('common.component')" name="component"></el-tab-pane>
        </el-tabs>
        <el-table
          v-show="activeName === 'device'"
          ref="table"
          border
          max-height="400"
          :data="deviceList"
          :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
          :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
          header-cell-class-name="headerCellName"
          row-key="id"
          default-expand-all>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-table
                max-height="100%"
                border
                :data="scope.row.subDevice"
                :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
                :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
                header-cell-class-name="headerCellName"
                row-key="id">
                <el-table-column prop="addr" :label="$t('common.address')"/>
                <el-table-column prop="deviceName" :label="$t('common.componentName')"/>
                <el-table-column prop="deviceModel" :label="$t('common.componentModel')"/>
                <el-table-column prop="deviceNo" :label="$t('common.componentNumber')"/>
                <el-table-column prop="productionDate" :label="$t('common.productionDate')">
                  <template slot-scope="scope">
                    {{ formatDate(scope.row.productionDate) }}
                  </template>
                </el-table-column>
                <el-table-column prop="softwareVersion" :label="$t('common.softwareVersion')"/>
                <el-table-column prop="deviceSerialNo" :label="$t('common.componentSerialNo')"/>
                <el-table-column prop="status" :label="$t('common.status')">
                  <template slot-scope="scope">
                    {{ subDeviceStatusVal(scope.row) }}
                  </template>
                </el-table-column>
                <el-table-column width="180" prop="num" :label="$t('common.count')">
                  <template slot-scope="props">
                    <el-input
                      v-model.trim.number="props.row.num"
                      type="tel"
                      autocomplete="on"
                      clearable
                      size="small"
                      maxlength="10"
                    />
                  </template>
                </el-table-column>
                <el-table-column width="180" prop="unit" :label="$t('common.unit')">
                  <template slot-scope="props">
                    <el-input
                      v-model.trim="props.row.unit"
                      type="text"
                      autocomplete="on"
                      clearable
                      size="small"
                      maxlength="10"
                    />
                  </template>
                </el-table-column>
                <el-table-column width="180" prop="comment" :label="$t('common.comment')">
                  <template slot-scope="props">
                    <el-input
                      v-model.trim="props.row.comment"
                      type="text"
                      autocomplete="on"
                      clearable
                      size="small"
                      maxlength="255"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.deviceCategory')">
            <template slot-scope="scope">
              {{ deviceCategoryVal(scope.row.flag) }}
            </template>
          </el-table-column>
          <el-table-column prop="addr" :label="$t('common.address')"/>
          <el-table-column prop="deviceName" :label="$t('common.deviceName')"/>
          <el-table-column prop="deviceModel" :label="$t('common.deviceModel')"/>
          <el-table-column prop="deviceNo" :label="$t('common.deviceNumber')"/>
          <el-table-column prop="productionDate" :label="$t('common.productionDate')">
            <template slot-scope="scope">
              {{ formatDate(scope.row.productionDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="installationDate" :label="$t('common.installDate')">
            <template slot-scope="scope">
              {{ formatDate(scope.row.installationDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="softwareVersion" :label="$t('common.softwareVersion')"/>
          <el-table-column :label="$t('common.status')">
            <template slot-scope="scope">
              {{ deviceStatusVal(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column width="180" prop="num" :label="$t('common.count')">
            <template slot-scope="scope">
              <el-input
                v-model.trim.number="scope.row.num"
                type="tel"
                autocomplete="on"
                clearable
                size="small"
                maxlength="9"
              />
            </template>
          </el-table-column>
          <el-table-column width="180" prop="unit" :label="$t('common.unit')">
            <template slot-scope="scope">
              <el-input
                v-model.trim="scope.row.unit"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="10"
              />
            </template>
          </el-table-column>
          <el-table-column width="180" prop="comment" :label="$t('common.comment')">
            <template slot-scope="scope">
              <el-input
                v-model.trim="scope.row.comment"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="255"
              />
            </template>
          </el-table-column>
        </el-table>
        <el-table
          v-show="activeName === 'component'"
          max-height="400"
          border
          :data="subDevice"
          :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
          :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
          header-cell-class-name="headerCellName"
          row-key="id">
          <el-table-column prop="addr" :label="$t('common.address')"/>
          <el-table-column prop="deviceName" :label="$t('common.componentName')"/>
          <el-table-column prop="deviceModel" :label="$t('common.componentModel')"/>
          <el-table-column prop="deviceNo" :label="$t('common.componentNumber')"/>
          <el-table-column prop="productionDate" :label="$t('common.productionDate')">
            <template slot-scope="scope">
              {{ formatDate(scope.row.productionDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="softwareVersion" :label="$t('common.softwareVersion')"/>
          <el-table-column prop="deviceSerialNo" :label="$t('common.componentSerialNo')"/>
          <el-table-column prop="status" :label="$t('common.status')">
            <template slot-scope="scope">
              {{ subDeviceStatusVal(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column width="180" prop="num" :label="$t('common.count')">
            <template slot-scope="scope">
              <el-input
                v-model.trim.number="scope.row.num"
                type="tel"
                autocomplete="on"
                clearable
                size="small"
                maxlength="9"
              />
            </template>
          </el-table-column>
          <el-table-column width="180" prop="unit" :label="$t('common.unit')">
            <template slot-scope="scope">
              <el-input
                v-model.trim="scope.row.unit"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="10"
              />
            </template>
          </el-table-column>
          <el-table-column width="180" prop="comment" :label="$t('common.comment')">
            <template slot-scope="scope">
              <el-input
                v-model.trim="scope.row.comment"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="255"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="control-container">
      <div>
        <el-button @click="prevStep" size="small" class="prev-button">
          {{$t('common.prevStep')}}
        </el-button>
        <el-button :loading="loading" @click="submitForm" size="small" class="sure-button">
          {{$t('common.save')}}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {
  deviceDeliveryAdd,
} from '@/api/device';
import {
  Pagination,
} from '@/components';
import {
  defaultCategoryTypes,
  defaultDeviceStatus,
  defaultSubDeviceStatus,
} from '@/utils/defines';
import {isPositiveIntegerNum, isValueEmpty} from "@/utils";
import i18n from "@/lang";
import {validateContactPhone} from "@/utils/validate";
import {customersList} from "@/api/customers";

const defaultForm = {
  no: undefined,
  customerId: undefined,
  contact: undefined,
  contactPhone: undefined,
  contactAddr: undefined,
  comment: undefined,
};

const categoryTypes = {
  ...defaultCategoryTypes,
  100: {
    val: 100,
    explain: i18n.t('common.component'),
  }
};

export default {
  name: "check-info",
  components: {
    Pagination,
  },
  props: {
    selectDevice: Array,
    selectSubDevice: Array,
  },
  data() {
    return {
      form: {...defaultForm, no: this.createNo()},
      rules: {
        no: [{required: true, trigger: 'change', message: this.$t('device.shipmentNumberCanNotBeEmpty')}],
        customerId: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.customerNameCanNotBeEmpty') }],
        contact: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.contactCanNotBeEmpty') }],
        contactPhone: [{ required: true, trigger: 'blur', validator: validateContactPhone }],
        contactAddr: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.contactCanNotBeEmpty') }],
      },
      loading: false,
      tempRoute: {},
      activeName: 'device',
      deviceList: [],
      subDevice: [],
      customersList: [],
    };
  },
  mounted() {
    this.tempRoute = Object.assign({}, this.$route);
    if (this.selectDevice) {
      this.deviceList = this.selectDevice.map(item => {
        return {
          ...item,
          num: 1,
          unit: '台',
          subDevice: item.subDevice.map(it => {
            return {
              ...it,
              num: 1,
              unit: '台',
            };
          })
        };
      });
    }
    if (this.selectSubDevice) {
      this.subDevice = this.selectSubDevice.map(item => {
        return {
          ...item,
          num: 1,
          unit: '台'
        };
      })
    }
    this.customersListGet(1, 2000);
  },
  methods: {
    submitForm() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          this.deviceDeliveryAdd();
        }
      });
    },
    async deviceDeliveryAdd() {
      const {
        no,
        customerId,
        contact,
        contactPhone,
        contactAddr,
        comment,
      } = this.form;
      const {
        deviceList,
        subDevice,
      } = this;
      let devices = [];
      if (deviceList) {
        for (let row of deviceList) {
          if (isValueEmpty(row.num)) {
            this.$message({
              type: 'error',
              message: this.$t('common.device') + this.$t('device.numberCanNotBeEmpty'),
            });
            return false;
          }
          if (!isPositiveIntegerNum(row.num)) {
            this.$message({
              type: 'error',
              message: this.$t('common.device') + this.$t('device.numberMustMoreThan0'),
            });
            return false;
          }
          devices.push({
            id: row.id,
            num: row.num,
            unit: row.unit || undefined,
            comment: row.comment || undefined,
          });
          if (row.subDevice) {
            for (let it of row.subDevice) {
              if (isValueEmpty(it.num)) {
                this.$message({
                  type: 'error',
                  message: this.$t('common.device') + this.$t('common.under') + this.$t('common.component')  + this.$t('device.numberCanNotBeEmpty'),
                });
                return false;
              }
              if (!isPositiveIntegerNum(it.num)) {
                this.$message({
                  type: 'error',
                  message: this.$t('common.device') + this.$t('common.under') + this.$t('common.component') + this.$t('device.numberMustMoreThan0'),
                });
                return false;
              }
              devices.push({
                id: it.id,
                num: it.num,
                unit: it.unit || undefined,
                comment: it.comment || undefined,
              });
            }
          }
        }
      }
      if (subDevice) {
        for (let row of subDevice) {
          if (isValueEmpty(row.num)) {
            this.$message({
              type: 'error',
              message: this.$t('common.component') + this.$t('device.numberCanNotBeEmpty'),
            });
            return false;
          }
          if (!isPositiveIntegerNum(row.num)) {
            this.$message({
              type: 'error',
              message: this.$t('common.component') + this.$t('device.numberMustMoreThan0'),
            });
            return false;
          }
          devices.push({
            id: row.id,
            num: row.num,
            unit: row.unit || undefined,
            comment: row.comment || undefined,
          });
        }
      }
      this.loading = true;
      try {
        await deviceDeliveryAdd({
          no: no,
          customerId,
          contact,
          contactPhone,
          contactAddr,
          comment: isValueEmpty(comment) ? undefined : comment,
          devices: devices && devices.length > 0 ? devices : undefined,
        });
        this.$message({
          type: 'success',
          message: this.$t('common.createSuccess'),
        });
        this.backDeviceDeliveryListPage();
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    createNo() {
      let str = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789';
      let n = 4;
      let s = '';
      let rand = '';
      let length = str.length;
      for (let i = 0; i < n; i++) {
        rand = Math.floor(Math.random() * length);
        s += str.charAt(rand);
      }
      return 'NT' + moment().format('YYMM') + s;
    },
    backDeviceDeliveryListPage() {
      this.$router.replace({path: '/asset-management/deviceDelivery'});
      this.$store.dispatch('tagsView/delView', this.tempRoute);
    },
    deviceCategoryVal(flag) {
      return categoryTypes[flag] ? `${categoryTypes[flag].explain}` : ''
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      return updateDate.local().format('YYYY/MM/DD');
    },
    deviceStatusVal(row) {
      const {
        status,
      } = row;
      const deviceStatus = defaultDeviceStatus[String(status)];
      return deviceStatus ? deviceStatus.explain : status;
    },
    subDeviceStatusVal(row) {
      const {
        status,
      } = row;
      const subDeviceStatus = defaultSubDeviceStatus[String(status)];
      return subDeviceStatus ? subDeviceStatus.explain : status;
    },
    prevStep() {
      this.$emit('prevStep');
    },
    async customersListGet(page, perpage) {
      try {
        const res = await customersList({ page, perpage, });
        const { data } = res;
        this.customersList = data.records;
        if (this.customersList && this.customersList.length > 0) {
          const {
            id,
            contact,
            contactPhone,
            contactAddr,
          } = this.customersList[0];
          this.form.customerId = id;
          this.form.contact = contact;
          this.form.contactPhone = contactPhone;
          this.form.contactAddr = contactAddr;
        }
      } catch (e) {
        // do nothing.
      }
    },
    changeCustomer(val) {
      if (val) {
        for (const row of this.customersList) {
          if (row.id === val) {
            this.form.contact = row.contact;
            this.form.contactPhone = row.contactPhone;
            this.form.contactAddr = row.contactAddr;
            this.$refs.refForm.validateField(['customerId', 'contact', 'contactPhone', 'contactAddr']);
            break;
          }
        }
      }
    },
  }
}
</script>

<style scoped>
.container {
  height: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.el-form {
  padding: 10px 20px 0;
}
.el-form-item {
  margin-bottom: 10px;
}
.control-container {
  background: #F5F5F5;
  padding: 20px;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: flex-end;
}

.topContainer {
  height: 100%;
  overflow: auto;
  flex: 1;
}

.target-container {
  margin: 0 20px 0;
}
.prev-button {
  background: white;
  color: #EC7900;
  border: #EC7900 solid 1px;
}
.sure-button {
  background: #EC7900;
  color: white;
}
</style>
<style>
.headerCellName {
  background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
  background: -o-linear-gradient(#F9F9F9, #EEEEEE);
  background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
  background: linear-gradient(#F9F9F9, #EEEEEE);
}

.small_label .el-form-item__label {
  font-size: 12px;
}
</style>
